import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["main", "card", "addNewOpportunityBtn", "4444", "5555", "applicantCard", "opportunityLeadName", "8888", "9999"]

  connect() {
    this.controllerName = `users--works--recruitments--applicants--pipeline--flow`
    this.controllerDashboard = this.getControllerByIdentifier("users--works--recruitments--applicants--pipeline--dashboard")
    this.controllerNumber = this.getControllerByIdentifier(`app--helpers--numbers`)
  }

  doDataFlow() {

    this.journeys = this.controllerDashboard.applicantJourneys()

    this.controllerDashboard.screeningFlowTarget.innerHTML = ``
    this.controllerDashboard.bookingFlowTarget.innerHTML = ``
    this.controllerDashboard.testingFlowTarget.innerHTML = ``
    this.controllerDashboard.interviewFlowTarget.innerHTML = ``
    this.controllerDashboard.closingFlowTarget.innerHTML = ``
    // this.controllerDashboard.onboardingFlowTarget.innerHTML = ``
    

    this.application.applicants.forEach(element => {
      this.doSimpleDataFlow(element)
    })
  }

  doSimpleDataFlow(element) {
    element.ticket_name = element.name

    var changeBtn = `Avançar`
    if (element.journey == `meeting`) {
      var changeBtn = `Realizado`
    }

    var html = `<div class="row my-2 cardRow" data-id="${element.id}" data-journey-number="${element.journey_number}" data-${this.controllerName}-target="card-${element.id} applicantCard">
                 <div class="col-12 px-1">
                   <div class="card">
                     <div class="card-body px-0 pt-1 pb-0 f-065">
                       <div class="row my-2 d-flex align-items-center">
                         <div class="col-12 px-1 pointer"> 
                           ${element.name}
                         </div>
                       </div>
                       <div class="row">
                         <div class="col-3 pl-0 pr-2">
                           <button data-action="click->${this.controllerName}#showTickets" type="button" class="btn btn-sm btn-table p-0 mc-tooltip">
                             <span class="material-icons md-sm md-dark">add_task</span>
                             <span class="mc-tooltiptext mc-tooltiptext-right">Adicionar Ticket</span>
                           </button>
                         </div>
                         <div class="col-3 px-2">
                           <button data-action="click->${this.controllerName}#addCheckNote" type="button" class="btn btn-sm btn-table p-0 mc-tooltip">
                             <span class="material-icons md-sm md-dark">note_add</span>
                             <span class="mc-tooltiptext mc-tooltiptext-right">Adicionar Nota de Check</span>
                           </button>
                         </div>
                         <div class="col-6 pl-2 pr-0">
                           <button data-action="click->${this.controllerName}#changeJourney" type="button" class="btn btn-sm btn-table p-0 w-100 mc-tooltip">
                             <span class="material-icons md-sm md-dark">trending_flat</span>
                             <span class="mc-tooltiptext mc-tooltiptext-right">${changeBtn}</span>
                           </button>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>`

    if (element.journey == `screening`) {
      this.controllerDashboard.screeningFlowTarget.insertAdjacentHTML("afterbegin", html)
    } else if (element.journey == `booking`) {
      this.controllerDashboard.bookingFlowTarget.insertAdjacentHTML("afterbegin", html)
    } else if (element.journey == `testing`) {
      this.controllerDashboard.testingFlowTarget.insertAdjacentHTML("afterbegin", html)
    } else if (element.journey == `interview`) {
      this.controllerDashboard.interviewFlowTarget.insertAdjacentHTML("afterbegin", html)
    } else if (element.journey == `closing`) {
      this.controllerDashboard.closingFlowTarget.insertAdjacentHTML("afterbegin", html)
    }
  }

  setTickets(element) {
    element.tickets.forEach(ticket => {
      if (ticket.performer_id == this.application.current_user.account_id) {
        ticket.url = element.url
        ticket.opportunity = element.ticket_name
        this.application.tickets[this.application.tickets.length] = ticket
      }
    })
  }

  doDataIndicator() {
    var screeningTotal = 0
    var bookingTotal = 0
    var testingTotal = 0
    var interviewTotal = 0
    var closingTotal = 0
    var onboardingTotal = 0

    if (this.application.applicants.length == 0) {

      this.controllerDashboard.screeningTotalTarget.innerText = screeningTotal
      this.controllerDashboard.bookingTotalTarget.innerText = bookingTotal
      this.controllerDashboard.testingTotalTarget.innerText = testingTotal
      this.controllerDashboard.interviewTotalTarget.innerText = interviewTotal
      this.controllerDashboard.closingTotalTarget.innerText = closingTotal
      // this.controllerDashboard.onboardingTotalTarget.innerText = onboardingTotal

    } else {
      this.application.applicants.forEach(element => {

        this.controllerDashboard.screeningTotalTarget.innerText = screeningTotal
        this.controllerDashboard.bookingTotalTarget.innerText = bookingTotal
        this.controllerDashboard.testingTotalTarget.innerText = testingTotal
        this.controllerDashboard.interviewTotalTarget.innerText = interviewTotal
        this.controllerDashboard.closingTotalTarget.innerText = closingTotal

        if (element.journey == `screening`) {
          screeningTotal += 1
          this.controllerDashboard.screeningTotalTarget.innerText = screeningTotal
        } else if (element.journey == `booking`) {
          bookingTotal += 1
          this.controllerDashboard.bookingTotalTarget.innerText = bookingTotal
        } else if (element.journey == `testing`) {
          testingTotal += 1
          this.controllerDashboard.testingTotalTarget.innerText = testingTotal
        } else if (element.journey == `interview`) {
          interviewTotal += 1
          this.controllerDashboard.interviewTotalTarget.innerText = interviewTotal
        } else if (element.journey == `closing`) {
          closingTotal += 1
          this.controllerDashboard.closingTotalTarget.innerText = closingTotal
        } else if (element.journey == `onboarding`) {
          onboardingTotal += 1
          this.controllerDashboard.onboardingTotalTarget.innerText = onboardingTotal
        }

      })
    }

  }

  showTickets(ev) {
    var applicantId = ev.currentTarget.closest(".cardRow").dataset.id
    this.current_applicant = {}

    this.application.applicants.forEach(element => {
      if (element.id == applicantId) {
        this.current_applicant = element
      }
    })

    this.getTickets()
  }

  getTickets() {
    this.getControllerByIdentifier(`app--helpers--pre-modal`).openProcessModal({ message: `Em processamento, aguarde!` })
    this.vacancy_tickets = []

    var data = { ticket: { board_id: this.application.vacancy.id, board_type: `recruitment_vacancies` }, current_user: { current_user_id: this.application.current_user.id, feature: `user_works_recruitments_tickets` } }
    const url = "/users/works/activities/tickets/list_by_board"
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        response.data.cln.forEach(element => {
          controller.vacancy_tickets[controller.vacancy_tickets.length] = element
        })

        controller.showTicketsBoard()
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  showTicketsBoard() {
    var controllerModal = `users--works--activities--shared--board-modal`

    var html = `<div class="modal fade" data-controller="${controllerModal}" data-${controllerModal}-target="modal" id="connectionModal" tabindex="-1" role="dialog" aria-labelledby="connectionModalTitle" aria-hidden="true" data-keyboard="false" data-backdrop="static">
                  <div class="modal-dialog modal-dialog-centered modal-slg" role="document">
                    <div class="modal-content">
                      <div class="modal-body p-0" data-${controllerModal}-target="body"></div>
                    </div>
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(document.body.insertAdjacentHTML("beforeend", html))
    }).then(() => {
      controller.getControllerByIdentifier(controllerModal).current_tickets = controller.vacancy_tickets
      controller.getControllerByIdentifier(controllerModal).obj_type = `recruitment_applicants`
      controller.getControllerByIdentifier(controllerModal).obj_id = controller.current_applicant.id
      // controller.getControllerByIdentifier(controllerModal).title = `${controller.current_applicant.name}`
      controller.getControllerByIdentifier(controllerModal).title = `Tickets | Recrutamento | ${controller.application.vacancy.name}`
      controller.getControllerByIdentifier(controllerModal).permission = `user_works_recruitments_tickets`
      // controller.getControllerByIdentifier(controllerModal).ticket_count_controller = controller.getControllerByIdentifier(`financials--books--receivables--dashboard--submenu`)
      controller.getControllerByIdentifier(controllerModal).ticket_board = {
        board_id: controller.application.vacancy.id,
        board_type: `recruitment_vacancies`,
        board_subtype: `recruitment_vacancies`,
        board_path: window.location.pathname,
        board_name: `Recrutamento | ${controller.application.vacancy.name}`,
        // date_id: controller.application.current_date.id,
        // date_type: `financials_dates`
      }
      controller.getControllerByIdentifier(controllerModal).comment_board = {
        board_id: controller.application.vacancy.id,
        board_type: `recruitment_vacancies`,
        // date_id: controller.application.current_date.id,
        // date_type: `financials_dates`
      }

      controller.getControllerByIdentifier(controllerModal).open()
    })
  }

  addCheckNote(ev) {
    var modal = `users--works--notes--save-check-modal`
    var applicantId = ev.currentTarget.closest(".cardRow").dataset.id
    var currentApplicant = {}

    this.application.applicants.forEach(element => {
      if (element.id == applicantId) {
        currentApplicant = element
      }
    })

    var html = `<div class="modal fade" data-controller="${modal}" data-${modal}-target="modal" id="connectionModal" tabindex="-1" role="dialog" aria-labelledby="connectionModalTitle" aria-hidden="true" data-keyboard="false" data-backdrop="static">
                  <div class="modal-dialog modal-dialog-centered modal" role="document">
                    <div class="modal-content">
                      <div class="modal-body p-0" data-${modal}-target="body"></div>
                    </div>
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(document.body.insertAdjacentHTML("beforeend", html))
    }).then(() => {
      controller.getControllerByIdentifier(modal).dashboardController = controller
      controller.getControllerByIdentifier(modal).note_board = {
        account_id: controller.application.current_user.account_id,
        domain_id: controller.application.vacancy.id,
        domain_type: `recruitment_vacancies`,
        domain_name: `Recrutamento | ${controller.application.vacancy.name}`,
      }

      controller.getControllerByIdentifier(modal).current_obj = currentApplicant
      controller.getControllerByIdentifier(modal).title = `Check ${currentApplicant.name}`
      controller.getControllerByIdentifier(modal).noteTitle = `Check ${currentApplicant.name}`
      controller.getControllerByIdentifier(modal).permission = `user_works_recruitments_notes`
      controller.getControllerByIdentifier(modal).open()
    })
  }

  listCheckNote(ev) {
    var modal = `users--works--notes--list-check-modal`
    var applicantId = ev.currentTarget.closest(".cardRow").dataset.id
    var currentApplicant = {}

    this.application.applicants.forEach(element => {
      if (element.id == applicantId) {
        currentApplicant = element
      }
    })

    var html = `<div class="modal fade" data-controller="${modal}" data-${modal}-target="modal" id="connectionModal" tabindex="-1" role="dialog" aria-labelledby="connectionModalTitle" aria-hidden="true" data-keyboard="false" data-backdrop="static">
                  <div class="modal-dialog modal-dialog-centered modal" role="document">
                    <div class="modal-content">
                      <div class="modal-body p-0" data-${modal}-target="body"></div>
                    </div>
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(document.body.insertAdjacentHTML("beforeend", html))
    }).then(() => {
      controller.getControllerByIdentifier(modal).dashboardController = controller
      controller.getControllerByIdentifier(modal).note_board = {
        account_id: controller.application.current_user.account_id,
        domain_id: controller.application.vacancy.id,
        domain_type: `recruitment_vacancies`,
        domain_name: `Recrutamento | ${controller.application.vacancy.name}`,
      }

      controller.getControllerByIdentifier(modal).current_obj = currentApplicant
      controller.getControllerByIdentifier(modal).title = `Recrutamento | ${controller.application.vacancy.name}`,
        controller.getControllerByIdentifier(modal).permission = `user_works_recruitments_notes`
      controller.getControllerByIdentifier(modal).open()
    })
  }

  goToURL(ev) {
    var url = ev.currentTarget.closest(".cardRow").dataset.url
    window.open(url, `_blank`)
  }

  addTicket(ev) {
    var id = ev.currentTarget.closest(".cardRow").dataset.id
  }

  changeJourney(ev) {

    var journeyNumber = Number(ev.currentTarget.closest(".cardRow").dataset.journeyNumber)
    var currentJourney = this.setNewJourney(journeyNumber)

    this.journeys.forEach(element => {
      if (element.name == currentJourney) {
        currentJourney = element
      }
    })

    if (currentJourney.name == `meeting`) {
      var r = confirm("Confirma a Contratação do Candidato?")
    } else {
      var r = confirm(`Confirma o Avanço do Candidato para ${currentJourney.next_pretty}?`)
    }

    if (r) {
      var applicantId = ev.currentTarget.closest(".cardRow").dataset.id

      this.send_data = { current_user: {}, applicant: {} }

      this.send_data.applicant.id = applicantId
      this.send_data.applicant.journey = currentJourney.next

      this.send_data.current_user.current_user_id = this.application.current_user.id
      this.send_data.current_user.feature = this.permission

      this.requestSave()
    }
  }

  requestSave() {
    this.getControllerByIdentifier(`app--helpers--pre-modal`).openProcessModal({ message: `Em processamento, aguarde!` })

    var url = "/users/works/recruitments/applicants/update"
    var method = "PUT"
    const init = { method: method, credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(this.send_data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.save) {
          var applicant = response.data.cln.applicant

          controller.application.applicants.forEach((element, i) => {
            if (element.id == applicant.id) {
              controller.application.applicants.splice(controller.application.applicants.indexOf(element), 1, applicant)
            }
          })

          controller.getControllerByIdentifier("users--works--recruitments--applicants--list").doDataTable()
          controller.doFlowHtml()
        }
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  doFlowHtml() {
    this.doDataFlow()
    this.doDataIndicator()
  }

  setNewJourney(journeyNumber) {
    var all_journeys = ["screening", "booking", "testing", "interview", "closing", "onboarding"]

    return all_journeys[journeyNumber]
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
